import wrapWithAuthentication from './src/auth/wrap-with-authentication';

export const wrapRootElement = wrapWithAuthentication;
